import AccesRapide from "./AccesRapide";

const HelpTopicConfigureCompte = () => {
  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Configurer votre compte', link: '/topics/compte'},
  ];

  const content = <>
    <p className="help-text">
      Vous êtes déjà sur votre compte et vous avez besoin de le modifier. Où faut-il se rendre ? Voici des informations sur la mise à jour de votre profil, 
      la gestion des paramètres de notification (comme la réception d'e-mails ou de SMS) et la modification de votre mot de passe pour vous aider à configurer 
      votre compte comme vous le souhaitez.
    </p>
    <p className="mt-48 fw-600 fz-20 mb-12">Modifier mes informations personnelles</p>
    <p className="help-text border-bottom pb-32 mb-0">
      Pour qu'un organisateur ou Wodzone puisse vous joindre, il est important que votre compte reste à jour. Une fois dans votre compte, ouvrez votre 
      <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings`}>compte</a>pour modifier des éléments tels que votre 
      adresse e-mail ou votre numéro de téléphone. Notez que certaines des informations figurant sur votre compte seront publiques (comme votre photo ou votre prénom), 
      mais les autres données resteront privées, telles que votre adresse postale, vos informations de paiement ou votre adresse e-mail.
    </p>
  </>

  return (
    <AccesRapide 
      goBackLinks={goBackLinks} guideInfo='Guide • Athlète' 
      img="https://res.cloudinary.com/dkz9knsgj/image/upload/v1736343802/img_configure_compte.jpg" content={content} topicsIds={[9, 10, 8, 13]}
    />
  );
}

export default HelpTopicConfigureCompte